module.exports = __webpack_public_path__ + "img/yuyuezhong.45823989.png";